/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfacePrizeTier } from './SurfacePrizeTier';
import {
    SurfacePrizeTierFromJSON,
    SurfacePrizeTierFromJSONTyped,
    SurfacePrizeTierToJSON,
    SurfacePrizeTierToJSONTyped,
} from './SurfacePrizeTier';

/**
 * 
 * @export
 * @interface SurfacePrizeItem
 */
export interface SurfacePrizeItem {
    /**
     * 
     * @type {SurfacePrizeTier}
     * @memberof SurfacePrizeItem
     */
    tier?: SurfacePrizeTier;
    /**
     * 
     * @type {string}
     * @memberof SurfacePrizeItem
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfacePrizeItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfacePrizeItem
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfacePrizeItem
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfacePrizeItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfacePrizeItem
     */
    quantity?: number;
}



/**
 * Check if a given object implements the SurfacePrizeItem interface.
 */
export function instanceOfSurfacePrizeItem(value: object): value is SurfacePrizeItem {
    return true;
}

export function SurfacePrizeItemFromJSON(json: any): SurfacePrizeItem {
    return SurfacePrizeItemFromJSONTyped(json, false);
}

export function SurfacePrizeItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfacePrizeItem {
    if (json == null) {
        return json;
    }
    return {
        
        'tier': json['tier'] == null ? undefined : SurfacePrizeTierFromJSON(json['tier']),
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'value': json['value'] == null ? undefined : json['value'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function SurfacePrizeItemToJSON(json: any): SurfacePrizeItem {
    return SurfacePrizeItemToJSONTyped(json, false);
}

export function SurfacePrizeItemToJSONTyped(value?: SurfacePrizeItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tier': SurfacePrizeTierToJSON(value['tier']),
        'title': value['title'],
        'description': value['description'],
        'value': value['value'],
        'imageId': value['imageId'],
        'imageUrl': value['imageUrl'],
        'quantity': value['quantity'],
    };
}

